
interface VipBadgeProps {
  badge: string;
  badgeColor: string;
  size?: 'sm' | 'md';
}

export default function VipBadge({ badge, badgeColor, size = 'sm' }: VipBadgeProps) {
  return (
    <span
      className={`inline-flex items-center font-bold text-white rounded-full whitespace-nowrap ${
        size === 'sm' ? 'text-xs px-2 py-0.5' : 'text-xs px-2.5 py-1'
      }`}
      style={{ backgroundColor: badgeColor }}
    >
      <i className="ri-award-fill mr-0.5" style={{ fontSize: size === 'sm' ? '10px' : '12px' }}></i>
      {badge}
    </span>
  );
}
